import { render, staticRenderFns } from "./CategoryTimedEvents.vue?vue&type=template&id=3f562888"
import script from "./CategoryTimedEvents.vue?vue&type=script&lang=ts"
export * from "./CategoryTimedEvents.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports